<template>
  <div class="col-10">
    <h4 class="page-header left">
      <p>Entité : {{ this.$route.params.entiteDesc }} </p>
      <p>Genre : {{ this.$route.params.genreDesc }} </p>
      <p>Nature : {{ this.$route.params.natureDesc }} </p>
      <p>Type : {{ this.$route.params.typeDesc }} </p>
    </h4>
  </div>
  <DataTable :value="categories" rowGroupMode="subheader" sortMode="single"
             resizableColumns columnResizeMode="expand"
             tableStyle="min-width: 50rem">
    <Column
        field="entite"
        header="Entité"
        :sortable="true"
    ></Column>
    <Column
        field= "genre"
        header="Genre"
        :sortable="true"
    ></Column>
    <Column
        field="nature"
        header="Nature"
        :sortable="true"
    ></Column>
    <Column
        field="type"
        header="Type"
        :sortable="true"
    ></Column>
    <Column
        field="description"
        header="Catégorie"
        :sortable="true"
    ></Column>
  </DataTable>
</template>

<script>
import axios from 'axios';
import {mapGetters} from "vuex";

export default {
  name: "TableValeurTableImpression",
  emits: ["isDataLoaded", "backendError"],
  beforeMount() {
    this.$root.$refs.breadcrumbComp.activeBallBeat = true;
    axios.defaults.headers.common['cleProfil'] = this.profil.cle;
    let libelleRecherche = {};
    libelleRecherche.valeur = this.$route.params.entite;
    libelleRecherche.enfant = {};
    libelleRecherche.enfant.valeur = this.$route.params.genre;
    libelleRecherche.enfant.enfant = {};
    libelleRecherche.enfant.enfant.valeur = this.$route.params.nature;
    libelleRecherche.enfant.enfant.enfant = {};
    libelleRecherche.enfant.enfant.enfant.valeur = this.$route.params.type;
    libelleRecherche.enfant.enfant.enfant.enfant = {};
    libelleRecherche.enfant.enfant.enfant.enfant.code = 'Categorie';
    this.categories = [];
    this.isRechercheDataLoading = true;
    this.$store.dispatch('pilotage/rechercherTableValeurAvecAscAction', libelleRecherche)
        .then((res) => {
              if (res.data !== null && res.data.libelles.length > 0) {
              res.data.libelles.forEach((currentEntite) => {
                currentEntite.tableValeur.libelles.forEach((currentGenre) => {
                  currentGenre.tableValeur.libelles.forEach((currentNature) => {
                    currentNature.tableValeur.libelles.forEach((currentType) => {
                      currentType.tableValeur.libelles.forEach((currentCategorie) => {
                        let currentCategorieComplete = currentCategorie;
                        currentCategorieComplete.entiteCle = currentEntite.tableValeur.cle
                        currentCategorieComplete.entite = currentEntite.tableValeur.description;
                        currentCategorieComplete.genreCle = currentGenre.tableValeur.cle
                        currentCategorieComplete.genre = currentGenre.tableValeur.description;
                        currentCategorieComplete.natureCle = currentNature.tableValeur.cle
                        currentCategorieComplete.nature = currentNature.tableValeur.description;
                        currentCategorieComplete.typeCle = currentType.tableValeur.cle;
                        currentCategorieComplete.type = currentType.tableValeur.description;
                        this.categories.push(currentCategorieComplete);
                      })
                    })
                  })
                })
              })
              } else {
                this.categories = this.formatterAucunAudit();
              }
          this.$root.$refs.breadcrumbComp.activeBallBeat = false;
        })
        .catch((err) => {
          this.$emit("backendError", err);
        })
        .finally(() => {
          this.$emit("isDataLoaded", true);
        })
  },
  data() {
    return {
      categories: [],
      AUDIT_FIELDS: [
        "modifierLe",
        "justificationTexte",
        "modifierParComplet",
        "abreviation",
        "description",
        "aide",
      ],
    };
  },
  computed: {
    ...mapGetters({
      jeton: "cardex/jeton",
      profil: 'cardex/profil',
    }),
  },
  methods: {
    formatterAucunAudit() {
      let listeAudits = [];
      let audit = {
        "entite": "",
        "genre": "",
        "nature": "",
        "type": "",
        "categorie": "",
      }
      let auditAffichage = {}
      this.AUDIT_FIELDS.forEach(field => {
        auditAffichage[field] = {texte: audit[field], isModifie: false,}
      })
      listeAudits.push(auditAffichage);
      return listeAudits;
    },
  },
};
</script>
